import type { SOPoolDetailDTCLabelInterface } from 'features/SupplyOrder/@types/XDock'

export type DTCLabelSkuItemType = {
  productName: string
  quantity: number
}

export type DTCLabelGroupType = {
  id: number | string
  soNumber: string
  hubName: string
  skuColumns: DTCLabelSkuItemType[][]
}

export const splitDTCLabelSkuItems = (items: DTCLabelSkuItemType[]) =>
  items.length <= 5 ? [items] : [items.slice(0, 5), items.slice(5)]

export const truncateDTCLabelSkuName = (name: string, maxLength: number) =>
  name.length > maxLength ? `${name.slice(0, maxLength - 3)}...` : name

export const groupDTCLabelDetails = (
  details: SOPoolDetailDTCLabelInterface[],
): DTCLabelGroupType[] => {
  const groups = new Map<
    string,
    Omit<DTCLabelGroupType, 'skuColumns'> & { skuItems: DTCLabelSkuItemType[] }
  >()

  details.forEach((detail) => {
    const supplyOrders = detail.list_so ?? []

    supplyOrders.forEach((supplyOrder) => {
      const existingGroup = groups.get(supplyOrder.supply_order_no)
      const skuItem = {
        productName: detail.product.name,
        quantity: supplyOrder.request_qty,
      }

      if (existingGroup) {
        existingGroup.skuItems.push(skuItem)
        return
      }

      groups.set(supplyOrder.supply_order_no, {
        id: supplyOrder.id,
        soNumber: supplyOrder.supply_order_no,
        hubName: supplyOrder.destination?.name ?? '',
        skuItems: [skuItem],
      })
    })
  })

  return Array.from(groups.values()).map(({ skuItems, ...group }) => ({
    ...group,
    skuColumns: splitDTCLabelSkuItems(skuItems),
  }))
}
